import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITimerService = ( createDecorator('timerService'));
export { ITimerService };
